import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, } from "@bracket/chainography";

import type { BlockHash, } from "@bracket/types";
import type { ResolverResult, } from "@types";
import type { Notification } from "@bracket/ui";

export const dispatchWithdrawalNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	if(result.success) {
		return withdrawSuccessNotification(result.hash);
	}
	if(result.rejected) {
		return null;
	}
	return withdrawFailedNotification(result.error);
}


export const withdrawSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Withdrawal successfully scheduled",
		message: "You successfully scheduled a withdrawal for this vault.",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}


export const withdrawFailedNotification = (error: Error): Omit<Notification, "id"> => {

  const msg = error.message.toLowerCase();
	const message = (
		// msg.includes("not a weistring") ? "invalid input, please check your values and try again" :
		// msg.includes("vaultnotlocked") ? "vault is not locked, please lock the vault before updating the NAV" :
		"please try again"
	);

	console.warn("withdrawal failed", error.message);

	return {
		title: "Withdrawal failure",
		message: `Scheduling a withdrawal for this vault failed, ${message}`,
		type: "error",
		status: "error",
	}

}
